THREE.FBXLoader = require('../../lib/FBXLoader');

/**
 * fbx-model
 *
 * Loader for FBX format. Supports ASCII, but *not* binary, models.
 */
module.exports = AFRAME.registerComponent('fbx-model', {
  schema: {
    src: {
      type: 'asset'
    },
    crossorigin: {
      default: ''
    }
  },
  init: function init() {
    this.model = null;
  },
  update: function update() {
    var data = this.data;
    if (!data.src) return;
    this.remove();
    var loader = new THREE.FBXLoader();
    if (data.crossorigin) loader.setCrossOrigin(data.crossorigin);
    loader.load(data.src, this.load.bind(this));
  },
  load: function load(model) {
    this.model = model;
    this.el.setObject3D('mesh', model);
    this.el.emit('model-loaded', {
      format: 'fbx',
      model: model
    });
  },
  remove: function remove() {
    if (this.model) this.el.removeObject3D('mesh');
  }
});